import { render, staticRenderFns } from "./SubImageContentViewer.vue?vue&type=template&id=5178137a&scoped=true"
import script from "./SubImageContentViewer.vue?vue&type=script&lang=js"
export * from "./SubImageContentViewer.vue?vue&type=script&lang=js"
import style0 from "./SubImageContentViewer.vue?vue&type=style&index=0&id=5178137a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5178137a",
  null
  
)

export default component.exports